<owl-carousel-o [options]="customOptions">
    <ng-container *ngFor="let job of latestJobs; let i=index">
    
        <ng-template carouselSlide [id]="job.id" >
            <div class="col-lg-3 pr-0 pl-0 latest-job-box">
                <div class="job-list pt-2 pl-0 pr-0 pb-0">
                    <div class="job-list-details col pl-2 pr-1">
                        <div class="job-list-title text-start">
                            <h6 class="mb-0 truncate-title"><a
                                    routerLink="/view-job/{{job.id}}/search-jobs">{{job.title}}</a></h6>
                        </div>
                        <div class="d-flex justify-content-between  carousel-cart">
                            <div>
                                <img class="img-fluid businessLogo" [src]="job.businessLogo == null ? photoPath : job.businessLogo" alt="Business Logo">
                            </div>
                            <div class="job-list-favourite-time">
                                <a class="job-list-favourite order-2" 
                                    [ngClass]="{bookmarked: job.bookmarked === true}" 
                                    [routerLink]=""
                                    (click)="onFavouriteClicked(job.id)">
                                    <i class="far fa-heart"></i>
                                </a>
                            </div>
                        </div>
                        <div class="job-list-info col pt-2 d-flex">
                            <!-- <div class="job-list-logo p-0">
                                <img class="img-fluid" [src]="job.businessLogo == null ? photoPath : job.businessLogo" alt="">
                            </div> -->
                            <div class="job-list-option text-start">
                                <ul class="list-unstyled flex-column">
                                    <li><i class="fas fa-map-marker-alt pr-1"></i>{{job.city}}, {{job.country}}
                                    </li>
                                    <li><i class="fas fa-filter pr-1"></i>{{job.sector}}</li>
                                    <li><a class="freelance" href="#"><i
                                                class="fas fa-suitcase pr-1"></i>{{job.type}}</a></li>
                                    <li><a class="freelance" href="#"><i
                                                class="fas flaticon-debit-card pr-1"></i>{{job.salaryRange}}</a>
                                    </li>
                                    <li *ngIf="job.applied == true" class="notice">
                                        You have already applied for this job on {{job.applicationDate | date:
                                        'mediumDate'}}
                                    </li>
                                </ul>
                            </div>
                            <!-- <div class="job-list-favourite-time">
                                <a class="job-list-favourite order-2" 
                                    [ngClass]="{bookmarked: job.bookmarked === true}" 
                                    [routerLink]=""
                                    (click)="onFavouriteClicked(job.id)">
                                    <i class="far fa-heart"></i>
                                </a>
                            </div> -->
                        </div>
                        <div *ngIf="job.totalAmountSpent" class="job-list-info col pt-2">
                            <div class="job-list-option">
                                <ul class="list-unstyled text-start">
                                    <li><i class="fas fa-money pr-1" title="Total Spent"></i>${{job.totalAmountSpent}}
                                        spent by JobPoster
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </ng-container>
</owl-carousel-o>